import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ThemeService} from '../../../../../lib-core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NgForm} from '@angular/forms';
import {ValidationService} from '../../../../services/validation.service';
import {TrackingAktion, TrackingCategory} from '../../../../models/enumTracking';
import {TrackingService} from '../../../../services/tracking.service';

@Component({
    selector: 'lv-modal-dialog-vorlage-changed',
    templateUrl: './modal-dialog-vorlage-changed.component.html',
    styleUrls: ['./modal-dialog-vorlage-changed.component.scss'],
    standalone: false
})
export class ModalDialogVorlageChangedComponent implements OnInit {
  @ViewChild(NgForm, {static: true})
  private _ngForm;

selectedOption: string;
portfolioName: string;
showSelectionRequiredError: boolean = false;

  constructor(private _themeService: ThemeService,
              public dialogRef: MatDialogRef<ModalDialogVorlageChangedComponent>,
              private _tracker: TrackingService,
              private _validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public data: { name: string }
  ) {

  }

  onUeberschreibenClicked() {
    this.resetShowSelectionRequiredError();
    this.portfolioName = '';
  }

  resetShowSelectionRequiredError() {
    this.showSelectionRequiredError = false;
  }

  ngOnInit(): void {
    this._themeService.setApplicationTheme(
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-primary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-secondary'),
        this._themeService.getThemeColor('lv-antragsannahme', '--lv-core-color-warn'), null,
        'mdc-dialog__container'
    );
  }
  speichernButtonClicked(): void {
    this._validationService.markControlsDirtyAndTouched(this._ngForm.form);
    if(!this.selectedOption) {
      this.showSelectionRequiredError = true;
    }
    if (this.selectedOption === 'ueberschreiben') {
      this._tracker.trackEvent(TrackingCategory.SPEICHERN, TrackingAktion.T_BUTTON, 'PortfolioSpeichern_Ueberschreiben');
        this.dialogRef.close({dosave: true});
      }
      if (this._ngForm.form.controls['portfolioName']?.status === 'VALID') {
      if (this.selectedOption === 'neuSpeichern') {
        this._tracker.trackEvent(TrackingCategory.SPEICHERN, TrackingAktion.T_BUTTON, 'PortfolioSpeichern_NeueVorlage');
        this.dialogRef.close({dosave: true, portfolioName: this.portfolioName});
      }
    }
  }
  abbrechenButtonClicked(): void {
    this.dialogRef.close({dosave: false});
  }


}
